export default __webpack_public_path__ + "static/media/OpeningVideoCreate_1mbs.db3b5aa1.jpg";